import { colors } from "@/theme/colors";
import { theme } from "@/theme/theme";
import { IThemeModeEnum } from "@/theme/types";

export function hexToRgb(hexString: string): string {
  // Remove the leading '#' if it's there
  const hex = hexString.trim().replace(/^#/, "");

  // Parse the hex string into the respective RGB components
  const red = Number.parseInt(hex.slice(0, 2), 16);
  const green = Number.parseInt(hex.slice(2, 4), 16);
  const blue = Number.parseInt(hex.slice(4, 6), 16);
  const alpha =
    hex?.length > 6 ? Number.parseInt(hex.slice(6, 8), 16) : undefined;

  // Return the RGB values as a string
  if (alpha) return `${red}, ${green}, ${blue}, ${alpha / 255}`;
  return `${red}, ${green}, ${blue}`;
}

export const createThemeVariables = (
  themeMode: IThemeModeEnum,
  createFunc: (name: string, value: string) => void,
) => {
  Object.entries(colors)?.map(([name, value]) => {
    createFunc(`--color-${name}`, value);
    createFunc(`--rgb-${name}`, hexToRgb(value));
    createFunc(`--theme-${name}`, hexToRgb(value));
  });

  const safeThemeMode = isThemeMode(themeMode)
    ? themeMode
    : IThemeModeEnum.Light;

  Object.entries(theme[safeThemeMode])?.map(([name, value]) => {
    createFunc(`--theme-${name}`, `var(--rgb-${value.colorKey})`);
  });
};

export function isThemeMode(value: string): value is IThemeModeEnum {
  return Object.values(IThemeModeEnum).includes(value as IThemeModeEnum);
}
